import {
  AvatarProps as MantineAvatarProps,
  Avatar as MantineAvatar,
  AvatarGroupProps as MantineAvatarGroupProps,
  AvatarGroup as MantineAvatarGroup,
} from '@mantine/core';

export type AvatarProps = MantineAvatarProps;

export type AvatarGroupProps = MantineAvatarGroupProps;

export const Avatar = MantineAvatar as typeof MantineAvatar;

Avatar.displayName = 'Avatar';

export const AvatarGroup = MantineAvatarGroup as typeof MantineAvatarGroup;

AvatarGroup.displayName = 'AvatarGroup';
